import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { cleengFormatPrice, formatAmount } from '@jwp/ott-common/src/utils/formatting';
import { useAccountStore } from '@jwp/ott-common/src/stores/AccountStore';

import Button from '../Button/Button';
import FormFeedback from '../FormFeedback/FormFeedback';
import CancelIcon from '../../../../theme/assets/icons/cancel_confirm.svg';
import { useTheme } from '../../../../../ThemeContext';

import styles from './CancelSubscriptionForm.module.scss';

type Props = {
  onConfirm: () => void;
  onCancel: () => void;
  error: string | null;
  submitting: boolean;
};

const CancelPlan: React.FC<Props> = ({ onConfirm, onCancel, error, submitting }: Props) => {
  const { t } = useTranslation('account');
  const { universalStyles } = useTheme();
  const pendingOffer = useAccountStore.getState().pendingOffer;
  const activeSubscription = useAccountStore((s) => s.subscription);

  const handleDescription = () => {
    const plan = <b className={styles.values}>{pendingOffer?.offerTitle} Plan</b>;
    const price = (
      <b className={styles.values}>
        {pendingOffer?.customerCurrencySymbol}
        {formatAmount(pendingOffer?.customerPriceInclTax ?? 0)}
      </b>
    );
    const baseStyle = { color: universalStyles.carouselPaginationInactive.backgroundColor, fontSize: 16 };

    return (
      <p style={baseStyle}>
        <Trans
          i18nKey="user:payment.cancel_plan_description"
          ns="user"
          values={{
            plan: `${pendingOffer?.offerTitle} Plan`,
            price: ` ${
              activeSubscription?.nextPaymentPrice
                ? cleengFormatPrice(activeSubscription?.nextPaymentPrice, activeSubscription?.nextPaymentCurrency, activeSubscription?.nextPaymentCurrency)
                : null
            }`,
          }}
          components={{
            1: <b className={styles.values} />,
            3: <b className={styles.values} />,
          }}
        />
      </p>
    );
  };

  return (
    <div>
      {error ? <FormFeedback variant="error">{error}</FormFeedback> : null}
      <span className={styles.icon}>
        <img src={CancelIcon} />
      </span>
      <h2 className={styles.title} style={universalStyles.primaryTextColor}>
        {t('user:payment.cancel_plan')}
      </h2>

      <p className={styles.paragraph} style={universalStyles.primaryTextColor}>
        {handleDescription()}
      </p>

      <div className={styles.buttonBar}>
        <span>
          <Button
            onClick={onConfirm}
            size="exlarge"
            variant="signoutYes"
            label={t('common:yes_proceed')}
            disabled={submitting}
            className={styles.confirmButton}
          />
        </span>
        <span>
          <Button
            onClick={onCancel}
            color="primary"
            size="exlarge"
            variant="signoutNo"
            label={t('common:no')}
            className={styles.confirmButton}
            disabled={submitting}
            style={universalStyles.signUpButton}
          />
        </span>
      </div>
    </div>
  );
};

export default CancelPlan;
